// src/features/mech/casting/questions/ManufacturingCountrySelect.jsx
import React from "react";
import { Box } from "@mui/material";
import PerlChip from "../../../../shared/components/PerlChip";
import PerlLabelMedium from "../../../../shared/components/PerlLabelMedium";
import PerlTextField from "../../../../shared/components/PerlTextField";

const COUNTRY_OPTIONS = [
  // "Albania",
  // "Argentina",
  // "Australia",
  // "Austria",
  // "Belgium",
  // "Bosnia",
  // "Brazil",
  // "Bulgaria",
  // "Canada",
  "China",
  // "Czech Republic",
  // "Denmark",
  // "Egypt",
  // "Finland",
  // "France",
  // "Germany",
  // "Greece",
  // "Hong Kong",
  // "Hungary",
  "India",
  // "Indonesia",
  // "Ireland",
  // "Italy",
  "Japan",
  // "Luxembourg",
  // "Malaysia",
  // "Mauritius",
  "Mexico",
  // "Morocco",
  // "Netherlands",
  // "New Zealand",
  // "Philiphines",
  // "Philippines",
  // "Poland",
  // "Portugal",
  // "Romania",
  // "Russia",
  // "Saudi Arabia",
  // "Serbia",
  "Singapore",
  // "Slovakia",
  // "Slovenia",
  // "South Africa",
  // "South Korea",
  // "Spain",
  // "Sri Lanka",
  // "Sweden",
  // "Switzerland",
  // "Taiwan",
  // "Thailand",
  // "Tunisia",
  // "Turkey",
  "UAE",
  "United Kingdom",
  "USA",
  "Vietnam",
];

export default function ManufacturingCountrySelect({ value, onChange }) {
  const selectedCountry = value || "";

  const handleCountrySelect = (country) => {
    // Toggle selection: if already selected, deselect; otherwise select
    const newValue = selectedCountry === country ? "" : country;
    onChange?.(newValue);
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      <PerlLabelMedium sx={{ mb: 2, display: "block" }}>Select Manufacturing Country</PerlLabelMedium>
      
      <PerlTextField
        label="Selected Manufacturing Country"
        placeholder="Select a country from below or enter custom country"
        value={selectedCountry}
        onChange={(e) => onChange?.(e.target.value)}
        fullWidth
      />
      
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: 1,
        }}
      >
        {COUNTRY_OPTIONS.map((country) => (
          <Box key={country} sx={{ width: "auto", flexShrink: 0 }}>
            <PerlChip
              label={country}
              onClick={() => handleCountrySelect(country)}
              selected={selectedCountry === country}
            />
          </Box>
        ))}
      </Box>
    </Box>
  );
}

